// Cette valeur est modifiée lors du build
export const APP_VERSION_VALUE = '20261026.1.1-2026102611'
export const BFF_KEY_VALUE = 'ah1MPO-izehIHD-QZZ9y88n-kku876'
